'use client';

import utilsStyles from '../../../../styles/modules/utils.module.scss';
import type { ContactFinishProps } from '../../types';

export interface ContactFinishUIProps extends ContactFinishProps {
  onNavigate: (path: string) => void;
  isAuthenticated: boolean;
}

function ContactFinish({ redirectPath, supportEmail, onNavigate, isAuthenticated }: ContactFinishUIProps) {
  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    onNavigate(redirectPath);
  };

  const content = (
    <>
      {isAuthenticated ? (
        <>
          お問い合わせに対する返信に関しては「
          {/* biome-ignore lint/a11y/useValidAnchor: <explanation> */}
          <a href='#' className={utilsStyles.textUnderlined} onClick={handleClick}>
            返信一覧ページ
          </a>
          」をご確認ください。
          <br />
          質問内容によっては回答出来ないまたは、回答まで時間を頂く場合がござます。
        </>
      ) : (
        <>
          {supportEmail}から返答されますので、
          <br />
          迷惑フィルタ等をご利用の場合は受信できるよう設定ください。
          <br />
          質問内容によっては回答出来ないまたは、回答まで時間を頂く場合がござます。
          <br />
        </>
      )}
    </>
  );

  return <p className={`${utilsStyles.textSmall} ${utilsStyles.mtSmall}`}>{content}</p>;
}

export default ContactFinish;
